<template>
  <section id="detailsSection" class="checkout-section" @input="handleInteraction">
    <div class="section-header">
      <h2>{{ resources.blockLabel }}</h2>
        <button v-if="!disableEditMode && !editMode && hasEnabledDeliveryMethods"
          @click="setEditState"
          class="btn btn--secondary"
        >
          {{ resources.editCTA }}
        </button>
    </div>

    <template v-if="disableEditMode || (!editMode && hasEnabledDeliveryMethods)">
      <details-summary/>
    </template>

    <template v-if="!disableEditMode && editMode && hasEnabledDeliveryMethods">
      <vue-form v-if="isb2b" id="companydetails" :name="checkout" :method="POST">
        <company-details ref="companyDetails" />
      </vue-form>
      <vue-form id="shippingForm" :name="checkout" :method="POST" :novalidate="false">
        <delivery-details ref="deliveryDetails" />
      </vue-form>
      <vue-form id="billingForm" :name="checkout" :method="POST" :novalidate="true">
        <billing-details ref="billingDetails">
            <div v-if="editMode && (hasSavedAddress || countryCode === 'US')" class="section-row">
              <div v-if="showEditModeError" class="inline-alert error">
                <span>{{ resources.saveSettingsWarning }}</span>
              </div>
              <footer :class="['section-footer', {'us-footer': countryCode === 'US' && !hasSavedAddress}]">
                <button class="btn" @click="saveDetails">
                  <span v-if="!saving">{{ resources.saveDetailsCTA }}</span>
                  <div :class="['spinner', 'white-spinner', { 'spinner-visible': saving }]">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>

                <a v-if="hasSavedAddress" title="Cancel" @click="revertEdit">{{ resources.cancelCTA }}</a>
              </footer>
            </div>
        </billing-details>
      </vue-form>
    </template>
  </section>
</template>
<script src="./details.js"/>
